import React, { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Banner } from './components/Banner';
import ScrollToTop from './components/ScrollToTop';
import { AnimationController } from './components/common/AnimationController';

// Lazy load all page components for code splitting
const HomePage = lazy(() => import('./pages/HomePage'));
const PricingPage = lazy(() => import('./pages/PricingPage'));
const FAQsPage = lazy(() => import('./pages/FAQsPage'));
const DatabasePage = lazy(() => import('./pages/DatabasePage'));
const WorkflowsPage = lazy(() => import('./pages/WorkflowsPage'));
const ProvenancePage = lazy(() => import('./pages/ProvenancePage'));
const IntegrationSharingPage = lazy(() => import('./pages/IntegrationSharingPage'));
const VisualisationPage = lazy(() => import('./pages/VisualisationPage'));
const SolutionsPage = lazy(() => import('./pages/SolutionsPage'));
const TermsAndConditionsPage = lazy(() => import('./pages/TermsAndConditionsPage'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ModellingPage = lazy(() => import('./pages/ModellingPage'));

// Loading component for lazy-loaded routes
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  </div>
);

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme') || 'light';
    setIsDarkMode(storedTheme === 'dark');
    document.documentElement.classList.add(storedTheme);
  }, []);

  return (
    <Router>
      <AnimationController>
        <div className={`App font-strawford ${isDarkMode ? 'dark' : ''}`}>
          <div className="text-gray-900 transition-transform duration-300 ease-in-out bg-white dark:bg-gray-900 dark:text-white">
            <ScrollToTop />
            <Banner />
          <Suspense fallback={<PageLoader />}>
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/faqs" element={<FAQsPage />} />
            <Route path="/workflows" element={<WorkflowsPage />} />
            <Route path="/provenance" element={<ProvenancePage />} />
            <Route path="/database" element={<DatabasePage />} />
            <Route path="/integration" element={<IntegrationSharingPage />} />
            <Route path="/sharing" element={<IntegrationSharingPage />} />
            <Route path="/visualisation" element={<VisualisationPage />} />
    
            <Route path="/about" element={<AboutPage />} />
            <Route path="/about/terms-and-conditions" element={<TermsAndConditionsPage />} />
            <Route path="/about/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsAndConditionsPage />} />
            <Route path="/modelling" element={<ModellingPage />} />
            </Routes>
          </Suspense>
          </div>
        </div>
      </AnimationController>
    </Router>
  );
}

export default App;
